import { useEffect } from 'react';
import { trackAAPageView } from 'services/adobe-analytics.service';
export var useRouteAnalytics = function (aaData) {
    var _a, _b;
    useEffect(function () {
        var _a;
        if (!((_a = aaData === null || aaData === void 0 ? void 0 : aaData.analytics) === null || _a === void 0 ? void 0 : _a.pageName)) {
            return;
        }
        trackAAPageView(aaData.analytics.pageName, aaData.analytics.pageProductName);
    }, [(_a = aaData === null || aaData === void 0 ? void 0 : aaData.analytics) === null || _a === void 0 ? void 0 : _a.pageName, (_b = aaData === null || aaData === void 0 ? void 0 : aaData.analytics) === null || _b === void 0 ? void 0 : _b.pageProductName]);
};
